// extracted by mini-css-extract-plugin
export default {"page":"f1-z","cartModal":"g1-z","checkout":"h1-z","placeholder":"i1-z","account":"j1-z"};